import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle.ts";

export const downloadFile = (fileHandle: FrontendDownloadFileHandle) => {
	const link = document.createElement("a");
	link.setAttribute("download", fileHandle.fileName);
	link.href = fileHandle.fileUrl;
	document.body.appendChild(link);
	link.click();
	link.remove();
};